export default [
  {
    symbol: "AED",
    polish_name: "Dirham ZEA",
    english_name: "Dirham ZEA"
  },
  {
    symbol: "AFN",
    polish_name: "Afgani",
    english_name: "Afghan afghani"
  },
  {
    symbol: "ALL",
    polish_name: "Lek",
    english_name: "Albanian lek"
  },
  {
    symbol: "AMD",
    polish_name: "Dram",
    english_name: "Armenian dram"
  },
  {
    symbol: "ANG",
    polish_name: "Gulden antylski",
    english_name: "Netherlands Antillean guilder"
  },
  {
    symbol: "AOA",
    polish_name: "Kwanza",
    english_name: "Angolan kwanza"
  },
  {
    symbol: "ARS",
    polish_name: "Peso argenty\u0144skie",
    english_name: "Argentine peso"
  },
  {
    symbol: "AUD",
    polish_name: "Dolar australijski",
    english_name: "Australian dollar"
  },
  {
    symbol: "AWG",
    polish_name: "Gulden/floren aruba",
    english_name: "Aruban florin"
  },
  {
    symbol: "AZN",
    polish_name: "Manat azerbejd\u017ca\u0144ski",
    english_name: "Azerbaijani manat"
  },
  {
    symbol: "BAM",
    polish_name: "Marka bo\u015bniacka",
    english_name: "Bosnia and Herzegovina convertible mark"
  },
  {
    symbol: "BBD",
    polish_name: "Dolar barbados",
    english_name: "Barbados dollar"
  },
  {
    symbol: "BDT",
    polish_name: "Taka",
    english_name: "Bangladeshi taka"
  },
  {
    symbol: "BGN",
    polish_name: "Lew",
    english_name: "Bulgarian lev"
  },
  {
    symbol: "BHD",
    polish_name: "Dinar bahrajsk",
    english_name: "Bahraini dinar"
  },
  {
    symbol: "BIF",
    polish_name: "Frank burundyjski",
    english_name: "Burundian franc"
  },
  {
    symbol: "BND",
    polish_name: "Dolar brunei",
    english_name: "Brunei dollar"
  },
  {
    symbol: "BOB",
    polish_name: "Boliwiano",
    english_name: "Boliviano"
  },
  {
    symbol: "BRL",
    polish_name: "Real brazylijski",
    english_name: "Brazilian real"
  },
  {
    symbol: "BSD",
    polish_name: "Dolar bahamski",
    english_name: "Bahamian dollar"
  },
  {
    symbol: "BTN",
    polish_name: "Ngultrum",
    english_name: "Bhutanese ngultrum"
  },
  {
    symbol: "BWP",
    polish_name: "Pula botswa\u0144ska",
    english_name: "Botswana pula"
  },
  {
    symbol: "BYN",
    polish_name: "Rubel bia\u0142oruski",
    english_name: "Belarusian ruble"
  },
  {
    symbol: "BZD",
    polish_name: "Dolar belize",
    english_name: "Belize dollar"
  },
  {
    symbol: "CAD",
    polish_name: "Dolar kanadyjski",
    english_name: "Canadian dollar"
  },
  {
    symbol: "CDF",
    polish_name: "Frank kongijski",
    english_name: "Congolese franc"
  },
  {
    symbol: "CHF",
    polish_name: "Frank szwajcarski",
    english_name: "Swiss franc"
  },
  {
    symbol: "CLP",
    polish_name: "Peso chilijskie",
    english_name: "Chilean peso"
  },
  {
    symbol: "CNY",
    polish_name: "Juan Renminbi",
    english_name: "Chinese yuan"
  },
  {
    symbol: "COP",
    polish_name: "Peso kolumbijskie",
    english_name: "Colombian peso"
  },
  {
    symbol: "CRC",
    polish_name: "Colon kostaryka\u0144ski",
    english_name: "Costa Rican colon"
  },
  {
    symbol: "CUP",
    polish_name: "Peso kuba\u0144skie ",
    english_name: "Cuban peso"
  },
  {
    symbol: "CVE",
    polish_name: "Escudo Zielonego Przyl\u0105dka",
    english_name: "Cape Verde escudo"
  },
  {
    symbol: "CZK",
    polish_name: "Korona czeska",
    english_name: "Czech koruna"
  },
  {
    symbol: "DJF",
    polish_name: "Frank d\u017cibuti",
    english_name: "Djiboutian franc"
  },
  {
    symbol: "DKK",
    polish_name: "Korona du\u0144ska",
    english_name: "Danish krone"
  },
  {
    symbol: "DOP",
    polish_name: "Peso dominika\u0144skie",
    english_name: "Dominican peso"
  },
  {
    symbol: "DZD",
    polish_name: "Dinar algierski",
    english_name: "Algerian dinar"
  },
  {
    symbol: "EGP",
    polish_name: "Funt egipski",
    english_name: "Egyptian pound"
  },
  {
    symbol: "ERN",
    polish_name: "Nakfa erytrejska",
    english_name: "Eritrean nakfa"
  },
  {
    symbol: "ETB",
    polish_name: "Birr etiopski",
    english_name: "Ethiopian birr"
  },
  {
    symbol: "EUR",
    polish_name: "Euro",
    english_name: "Euro"
  },
  {
    symbol: "FJD",
    polish_name: "Dolar fid\u017ci",
    english_name: "Fiji dollar"
  },
  {
    symbol: "FKP",
    polish_name: "Funt falklandzki ",
    english_name: "Falkland Islands pound"
  },
  {
    symbol: "GBP",
    polish_name: "Funt brytyjski",
    english_name: "Pound sterling"
  },
  {
    symbol: "GEL",
    polish_name: "Lari gruzi\u0144skie",
    english_name: "Georgian lari"
  },
  {
    symbol: "GHS",
    polish_name: "Cedi gha\u0144skie",
    english_name: "Ghanaian cedi"
  },
  {
    symbol: "GMD",
    polish_name: "Dalasi gambijskie",
    english_name: "Gambian dalasi"
  },
  {
    symbol: "GNF",
    polish_name: "Frank gwinejski",
    english_name: "Guinean franc"
  },
  {
    symbol: "GTQ",
    polish_name: "Quetzal gwatemalski",
    english_name: "Guatemalan quetzal"
  },
  {
    symbol: "GYD",
    polish_name: "Dolar guja\u0144ski",
    english_name: "Guyanese dollar"
  },
  {
    symbol: "HKD",
    polish_name: "Dolar hongko\u0144ski",
    english_name: "Hong Kong dollar"
  },
  {
    symbol: "HNL",
    polish_name: " \t\r\n\r\nLempira honduraska",
    english_name: "Honduran lempira"
  },
  {
    symbol: "HRK",
    polish_name: "Kuna chorwacka",
    english_name: "Croatian kuna"
  },
  {
    symbol: "HTG",
    polish_name: "Gourde haita\u0144skie",
    english_name: "Haitian gourde"
  },
  {
    symbol: "HUF",
    polish_name: "Forint w\u0119gierski",
    english_name: "Hungarian forint"
  },
  {
    symbol: "IDR",
    polish_name: "Rupia indonezyjska",
    english_name: "Indonesian rupiah"
  },
  {
    symbol: "ILS",
    polish_name: "Nowy szekel izraelski",
    english_name: "Israeli new shekel"
  },
  {
    symbol: "INR",
    polish_name: " \t\r\n\r\nRupia indyjska",
    english_name: "Indian rupee"
  },
  {
    symbol: "IQD",
    polish_name: "Dinar iracki",
    english_name: "Iraqi dinar"
  },
  {
    symbol: "IRR",
    polish_name: "Rial ira\u0144ski ",
    english_name: "Iranian rial"
  },
  {
    symbol: "ISK",
    polish_name: "Korona islandzka",
    english_name: "Icelandic kr\u00f3na"
  },
  {
    symbol: "JMD",
    polish_name: "Dolar jamajka",
    english_name: "Jamaican dollar"
  },
  {
    symbol: "JOD",
    polish_name: "Dinar jorda\u0144ski",
    english_name: "Jordanian dinar"
  },
  {
    symbol: "JPY",
    polish_name: "Jen japo\u0144ski",
    english_name: "Japanese yen"
  },
  {
    symbol: "KES",
    polish_name: "Szyling kenijski",
    english_name: "Kenyan shilling"
  },
  {
    symbol: "KGS",
    polish_name: "Som kirgiski",
    english_name: "Kyrgyzstani som"
  },
  {
    symbol: "KHR",
    polish_name: "Riel kambod\u017ca\u0144ski",
    english_name: "Cambodian riel"
  },
  {
    symbol: "KMF",
    polish_name: "Frank komoryjski ",
    english_name: "Comoro franc"
  },
  {
    symbol: "KPW",
    polish_name: "Won p\u00f3\u0142nocnokorea\u0144ski ",
    english_name: "North Korean won"
  },
  {
    symbol: "KRW",
    polish_name: "Won po\u0142udniowokorea\u0144ski ",
    english_name: "South Korean won"
  },
  {
    symbol: "KWD",
    polish_name: "Dinar kuwejcki",
    english_name: "Kuwaiti dinar"
  },
  {
    symbol: "KYD",
    polish_name: "Dolar kajma\u0144ski",
    english_name: "Cayman Islands dollar"
  },
  {
    symbol: "KZT",
    polish_name: "Tenge kazachskie",
    english_name: "Kazakhstani tenge"
  },
  {
    symbol: "LAK",
    polish_name: "Kip laota\u0144ski",
    english_name: "Lao kip"
  },
  {
    symbol: "LBP",
    polish_name: "Funt liba\u0144ski",
    english_name: "Lebanese pound"
  },
  {
    symbol: "LKR",
    polish_name: "Rupia Sri Lanka",
    english_name: "Sri Lankan rupee"
  },
  {
    symbol: "LRD",
    polish_name: "Dolar liberyjski",
    english_name: "Liberian dollar"
  },
  {
    symbol: "LSL",
    polish_name: "Loti lesoto",
    english_name: "Lesotho loti"
  },
  {
    symbol: "LYD",
    polish_name: "Dinar libijski",
    english_name: "Libyan dinar"
  },
  {
    symbol: "MAD",
    polish_name: "Dirham maroka\u0144ski",
    english_name: "Moroccan dirham"
  },
  {
    symbol: "MDL",
    polish_name: "Lej mo\u0142dawski",
    english_name: "Moldovan leu"
  },
  {
    symbol: "MGA",
    polish_name: "Ariary malgaski",
    english_name: "Malagasy ariary"
  },
  {
    symbol: "MKD",
    polish_name: "Denar macedo\u0144ski",
    english_name: "Macedonian denar"
  },
  {
    symbol: "MMK",
    polish_name: "Kiat",
    english_name: "Myanmar kyat"
  },
  {
    symbol: "MNT",
    polish_name: "Tugrik mongolski",
    english_name: "Mongolian t\u00f6gr\u00f6g"
  },
  {
    symbol: "MOP",
    polish_name: "Pataka makao",
    english_name: "Macanese pataca"
  },
  {
    symbol: "MRO",
    polish_name: "Ougiya maureta\u0144ska",
    english_name: "Mauritanian ouguiya"
  },
  {
    symbol: "MUR",
    polish_name: "Rupia maurytyjska",
    english_name: "Mauritian rupee"
  },
  {
    symbol: "MVR",
    polish_name: "Rufiyaa malediwska",
    english_name: "Maldivian rufiyaa"
  },
  {
    symbol: "MWK",
    polish_name: "Kwacha malawska",
    english_name: "Malawian kwacha"
  },
  {
    symbol: "MXN",
    polish_name: "Peso meksyka\u0144skie",
    english_name: "Mexican peso"
  },
  {
    symbol: "MYR",
    polish_name: "Ringgit malezyjski",
    english_name: "Malaysian ringgit"
  },
  {
    symbol: "MZN",
    polish_name: "Metical",
    english_name: "Mozambican metical"
  },
  {
    symbol: "NAD",
    polish_name: "Dolar namibijski",
    english_name: "Namibian dollar"
  },
  {
    symbol: "NGN",
    polish_name: "Naira nigeryjska",
    english_name: "Nigerian naira"
  },
  {
    symbol: "NIO",
    polish_name: "Cordoba oro nikaragua\u0144ska",
    english_name: "Nicaraguan c\u00f3rdoba"
  },
  {
    symbol: "NOK",
    polish_name: "Korona norweska",
    english_name: "Norwegian krone"
  },
  {
    symbol: "NPR",
    polish_name: "Rupia nepalska",
    english_name: "Nepalese rupee"
  },
  {
    symbol: "NZD",
    polish_name: "Dolar nowozelandzki",
    english_name: "New Zealand dollar"
  },
  {
    symbol: "OMR",
    polish_name: "Rial oma\u0144ski",
    english_name: "Omani rial"
  },
  {
    symbol: "PAB",
    polish_name: "Balboa panamski",
    english_name: "Panamanian balboa"
  },
  {
    symbol: "PEN",
    polish_name: "Nuevo sol peruwia\u0144ski",
    english_name: "Peruvian Sol"
  },
  {
    symbol: "PGK",
    polish_name: "Kina papua nowa gwinea",
    english_name: "Papua New Guinean kina"
  },
  {
    symbol: "PHP",
    polish_name: "Peso filipi\u0144skie",
    english_name: "Philippine peso"
  },
  {
    symbol: "PKR",
    polish_name: "Rupia pakista\u0144ska",
    english_name: "Pakistani rupee"
  },
  {
    symbol: "PLN",
    polish_name: "Polski z\u0142oty",
    english_name: "Polish z\u0142oty"
  },
  {
    symbol: "PYG",
    polish_name: "Guarani paragwajskie",
    english_name: "Paraguayan guaran\u00ed"
  },
  {
    symbol: "QAR",
    polish_name: "Rial katarski",
    english_name: "Qatari riyal"
  },
  {
    symbol: "RON",
    polish_name: "Lej rumu\u0144ski",
    english_name: "Romanian leu"
  },
  {
    symbol: "RSD",
    polish_name: "Dinar Serbski",
    english_name: "Serbian dinar"
  },
  {
    symbol: "RUB",
    polish_name: "Rubel rosyjski",
    english_name: "Russian ruble"
  },
  {
    symbol: "RWF",
    polish_name: "Frank rwandyjski",
    english_name: "Rwandan franc"
  },
  {
    symbol: "SAR",
    polish_name: "Rial saudyjski",
    english_name: "Saudi riyal"
  },
  {
    symbol: "SBD",
    polish_name: "Dolar Wysp Salomona",
    english_name: "Solomon Islands dollar"
  },
  {
    symbol: "SCR",
    polish_name: "Rupia seszelska",
    english_name: "Seychelles rupee"
  },
  {
    symbol: "SDG",
    polish_name: "Funt suda\u0144ski",
    english_name: "Sudanese pound"
  },
  {
    symbol: "SEK",
    polish_name: "Korona szwedzka",
    english_name: "Swedish krona/kronor"
  },
  {
    symbol: "SGD",
    polish_name: "Dolar singapurski",
    english_name: "Singapore dollar"
  },
  {
    symbol: "SHP",
    polish_name: "Funt \u015awi\u0119tej Heleny ",
    english_name: "Saint Helena pound"
  },
  {
    symbol: "SLL",
    polish_name: "Sierra Leone leone",
    english_name: "Sierra Leonean leone"
  },
  {
    symbol: "SOS",
    polish_name: "Szyling somalijski",
    english_name: "Somali shilling"
  },
  {
    symbol: "SRD",
    polish_name: "Dolar Surinam",
    english_name: "Surinamese dollar"
  },
  {
    symbol: "SSP",
    polish_name: "Dolar po\u0142udniowosuda\u0144ski",
    english_name: "South Sudanese pound"
  },
  {
    symbol: "STD",
    polish_name: "Dobra Wysp \u015awi\u0119tego Tomasza i Ksi\u0105\u017c\u0119cej",
    english_name: "S\u00e3o Tom\u00e9 and Pr\u00edncipe dobra"
  },
  {
    symbol: "SYP",
    polish_name: "Suazi lilangeni",
    english_name: "Syrian pound"
  },
  {
    symbol: "SZL",
    polish_name: "Suazi lilangeni",
    english_name: "Swazi lilangeni"
  },
  {
    symbol: "THB",
    polish_name: "Bat tajlandzki",
    english_name: "Thai baht"
  },
  {
    symbol: "TJS",
    polish_name: "Somoni tad\u017cyckie",
    english_name: "Tajikistani somoni"
  },
  {
    symbol: "TMT",
    polish_name: "Manat turkme\u0144ski ",
    english_name: "Turkmenistani manat"
  },
  {
    symbol: "TND",
    polish_name: "Dinar tunezyjski",
    english_name: "Tunisian dinar"
  },
  {
    symbol: "TOP",
    polish_name: "Pa'anga Tonga",
    english_name: "Tongan pa\u02bbanga"
  },
  {
    symbol: "TRY",
    polish_name: "Lira turecka",
    english_name: "Turkish lira"
  },
  {
    symbol: "TTD",
    polish_name: "Dolar Trynidad i Tobago",
    english_name: "Trinidad and Tobago dollar"
  },
  {
    symbol: "TWD",
    polish_name: "Dolar tajwa\u0144ski",
    english_name: "New Taiwan dollar"
  },
  {
    symbol: "TZS",
    polish_name: "Szyling tanza\u0144ski",
    english_name: "Tanzanian shilling"
  },
  {
    symbol: "UAH",
    polish_name: "Hrywna ukrai\u0144ska",
    english_name: "Ukrainian hryvnia"
  },
  {
    symbol: "UGX",
    polish_name: "Szyling ugandyjski",
    english_name: "Ugandan shilling"
  },
  {
    symbol: "USD",
    polish_name: "Dolar ameryka\u0144ski",
    english_name: "United States dollar"
  },
  {
    symbol: "UYU",
    polish_name: "Peso urugwajskie",
    english_name: "Uruguayan peso"
  },
  {
    symbol: "UZS",
    polish_name: "Som uzbecki",
    english_name: "Uzbekistan som"
  },
  {
    symbol: "VEF",
    polish_name: "Boliwar wenezuelski",
    english_name: "Venezuelan bol\u00edvar"
  },
  {
    symbol: "VND",
    polish_name: "Dong wietnamski",
    english_name: "Vietnamese \u0111\u1ed3ng"
  },
  {
    symbol: "VUV",
    polish_name: "Vatu Vanuatu",
    english_name: "Vanuatu vatu"
  },
  {
    symbol: "WST",
    polish_name: "Tala samoa\u0144ska",
    english_name: "Samoan tala"
  },
  {
    symbol: "XAF",
    polish_name: "Frank CFA BEAC",
    english_name: "CFA franc BEAC"
  },
  {
    symbol: "XCD",
    polish_name: "Dolar wschodniokaraibski",
    english_name: "East Caribbean dollar"
  },
  {
    symbol: "XOF",
    polish_name: "Frank CFA BCEAO",
    english_name: "CFA franc BCEAO"
  },
  {
    symbol: "XPF",
    polish_name: "Frank CFP",
    english_name: "CFP franc (franc Pacifique)"
  },
  {
    symbol: "YER",
    polish_name: "Rial jeme\u0144ski",
    english_name: "Yemeni rial"
  },
  {
    symbol: "ZAR",
    polish_name: "Rand po\u0142udniowoafryka\u0144ski",
    english_name: "South African rand"
  },
  {
    symbol: "ZMK",
    polish_name: "Kwacha zambijska",
    english_name: "Zambian kwacha"
  }
];
